import { FC } from "react";
import Modal from "../../components/Modal";
import LeagueFilterForm from "./LeagueFilterForm";
import { LeagueFilterFormProps } from "./LeagueFilterForm";
import Drawer from "@mui/material/Drawer";
import LeagueFilterFormMobile from "./LeagueFilterForm.mobile";

export type LeagueFilterModalProps = {
  isToggled: boolean;
  onClose: () => void;
  isDesktop?: boolean;
} & LeagueFilterFormProps;

const LeagueFilterModal: FC<LeagueFilterModalProps> = ({
  isToggled,
  defaultIsAllSelected,
  defaultSelectedLeagues,
  onClose,
  options,
  onSubmit,
  isDesktop = true
}) => {
  if (isDesktop) {
    return (
      <Modal open={isToggled} onClose={onClose}>
        <LeagueFilterForm
          defaultIsAllSelected={defaultIsAllSelected}
          defaultSelectedLeagues={defaultSelectedLeagues}
          options={options}
          onClose={onClose}
          onSubmit={onSubmit}
        />
      </Modal>
    );
  }

  return (
    <Drawer
      anchor="bottom"
      open={isToggled}
      onClose={(_e, _reason) => onClose()}
      PaperProps={{
        style: {
          height: `calc(100vh - 60px)`,
        },
      }}
    >
      <LeagueFilterFormMobile
        onClose={onClose}
        onSubmit={onSubmit}
        options={options}
        defaultIsAllSelected={defaultIsAllSelected}
        defaultSelectedLeagues={defaultSelectedLeagues}
      />
    </Drawer>
  );
};

export default LeagueFilterModal;
